export const serviceUnavailableEventName = 'inav:service-unavailable';
